<template>
  <div id="ProductsDetail">
    <Header />
    <div class="breadcrumb-bg">
      <el-breadcrumb separator-class="el-icon-arrow-right"
                     class="breadcrumb">
        <el-breadcrumb-item>
          <router-link class="link-back"
                       to="/">首頁</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item class="current">全新DAILY CAB車陣王</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bg-img animated fadeIn">
      <img class="c-on1"
           src="../..//images/videodaily/new_daily_cab_my2019_bannerinternal.jpg"
           alt="依维柯Daily Cab"
           title="依维柯Daily Cab" />
      <div class="c-on2">
        <span>改變你的商業視角</span>
        <img src="../..//images/videodaily/new_daily_cab_my2019_bannerinternal2.jpg"
             alt="依维柯Daily Cab"
             title="依维柯Daily Cab" />
      </div>
    </div>
    <div ref="detail"
         class="detail">
      <PTabs v-model="activeName"
             type="card"
             :tabs.sync="screenWidth"
             @tabClick="handleClick">
        <PTabPane label="全新DAILY CAB車陣王"
                  name="1">
          <div class="con">
            <h2>改變你<strong class="color">商業視角</strong>的車陣王</h2>
            <p>遠遠<strong>不止商用車，全新DAILY CAB車陣王</strong>務求助你的業務<strong>可持續發展及符合經濟效益。</strong></p>
            <p>與<strong>全新DAILY CAB車陣王為伴，科技所帶來的簡便長伴你左右：</strong>終日在車上忙碌奔波，擁有一流的車上<strong>生活配置和駕駛體驗</strong>是駕駛者所渴望。在40年的歷史中，DAILY一直不斷改進，把你的<strong>生活與駕駛體驗提升至業內最高水準。</strong></p>
            <p><img style="margin-top: 30px;"
                   src="../../images/videodaily/Overview_dailycab.jpg" /></p>
            <p><strong>DAILY</strong>具有<strong>高連貫性，</strong>為你<strong>接通對個性化定制服務需求日益增加的全新世界，</strong>以完全滿足你對商用車輛使用的要求。</p>
            <p><strong>它是為你的業務度身定制的完整運輸解決方案。</strong></p>
          </div>
          <div class="con">
            <h5>你要知道三件關於全新DAILY CAB車陣王的重點</h5>
            <ul class="three-list">
              <li>
                <img src="../../images/icon/ico_consuption.jpg" />
                <strong style="font-size: 16px;">燃油量和維修費用</strong>
                <p style="font-size: 15px; margin-bottom: 10px;">減少油耗及維修費用</p>
                <i class="el-icon-circle-plus-outline"
                   @click="dialogVisibleConsuption = true"></i>

                <el-dialog class="vdialog"
                           title="燃油量和維修費用"
                           :visible.sync="dialogVisibleConsuption"
                           :before-close="handleClose"
                           :lockScroll="true"
                           size="tiny">
                  <p class="no-margin"><strong>DAILY的高效性能為你實現更高的節油效果</strong></p>
                  <p class="margin18">全新DAILY引擎的<strong>燃油效能脫穎而出，</strong>這得益於於其補充特性，例如<strong>新的電控可變截面渦輪增壓器，</strong>專為DAILY獨家打造的<strong>Super Eco節能輪胎</strong>和<strong>全新Auto Start/Stop自動停車熄匙系統。</strong></p>
                  <p class="no-margin"><strong>大大節省維修費用</strong></p>
                  <p class="margin18">不斷的創新和更長的換油週期，在城市環境中工作時可<strong>節省</strong>更多的<strong>維護成本。</strong></p>
                  <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                           target="_blank"
                           class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
                </el-dialog>
              </li>
              <li>
                <img src="../../images/icon/ico_weight.jpg" />
                <strong style="font-size: 16px;">車輛總重量</strong>
                <p style="font-size: 15px; margin-bottom: 10px;">從3.5噸至7.2噸</p>
                <i class="el-icon-circle-plus-outline"
                   @click="dialogVisibleWeight = true"></i>

                <el-dialog class="vdialog"
                           title="車輛總重量 無限機遇"
                           :visible.sync="dialogVisibleWeight"
                           :before-close="handleClose"
                           :lockScroll="true"
                           size="tiny">
                  <p class="margin18">無論從事何種業務，您都會發現Daily 最匹配您的需求。總車重從3.5 至7.2 噸，軸距從3000 至5100 mm，車身長度可達6190mm，是同類中適用範圍最廣的車型。充分享用全新DAILYCAB車陣王的優勢，由於採用高強度鋼製造的C型車架，它最堅固結實，最容易改裝。</p>
                  <div class="carWeight">
                    <table>
                      <thead>
                        <tr>
                          <th>
                            <font style="vertical-align: inherit;">單排座駕駛室底盤</font>
                          </th>
                          <th>
                            <font style="vertical-align: inherit;">雙排座駕駛室底盤</font>
                          </th>
                          <th style="border: 0;">
                            <font style="vertical-align: inherit;">三類底盤</font>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><img src="../../images/videodaily/chassis-cab.png"
                                 alt="單排座駕駛室底盤"></td>
                          <td><img src="../../images/videodaily/crew-cab.png"
                                 alt="雙排座駕駛室底盤"></td>
                          <td style="border: 0;"><img src="../../images/videodaily/chassis-cown.png"
                                 alt="三類底盤"></td>
                        </tr>
                        <tr>
                          <td>
                            <font style="vertical-align: inherit;">3.5-7.2噸</font>
                          </td>
                          <td>
                            <font style="vertical-align: inherit;">3.5-7噸</font>
                          </td>
                          <td style="border: 0;">
                            <font style="vertical-align: inherit;">3.5-7.2噸</font>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                           target="_blank"
                           class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
                </el-dialog>
              </li>
              <li>
                <img src="../../images/icon/icon_range.jpg" />
                <strong style="font-size: 16px;">車體選項</strong>
                <p style="font-size: 15px; margin-bottom: 10px;">業內最廣泛的產品陣容</p>
                <i class="el-icon-circle-plus-outline"
                   @click="dialogVisibleOutline = true"></i>

                <el-dialog class="vdialog"
                           title="車體選項 極高的可定制性"
                           :visible.sync="dialogVisibleOutline"
                           :before-close="handleClose"
                           :lockScroll="true"
                           size="tiny">
                  <p>Daily 獨有的設計和構造方式帶來了<strong>廣泛的車體解決方案，</strong>讓你可根據特定需求輕鬆定制。</p>
                  <p class="margin18">它最適合高度專業和要求苛刻的應用，也適用於載人，例如救援車，工程車或救護車等﹐都可全面適應各類需求。</p>

                  <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                           target="_blank"
                           class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
                </el-dialog>
              </li>
            </ul>
          </div>

          <div ref="videoDaily1_con"
               class="con video-con">
            <a class="video-title">NEW DAILY<br>CHANGE YOUR BUSINESS PERSPECTIVE</a>
            <video ref="videoDaily1"
                   muted
                   webkit-playsinline="true"
                   playsinline="true"
                   x5-playsinline="true"
                   class="video-product"
                   style="width: 100%; margin-top:0;"
                   poster="../../images/videodaily/video_daily_ADV_ok2.jpg"
                   controls="controls"
                   width="100%"
                   height="auto">
              <!-- <source src="http://www.iveco.com.cn/video/Iveco_Daily2019.mp4" type="video/mp4"> -->
              <source :src="`${url}/iveco/iveco-images/videodaily/video/Iveco_Daily2019.mp4`"
                      type="video/mp4">
            </video>
          </div>
        </PTabPane>
        <PTabPane label="承重力和容量"
                  name="2">
          <div class="load-title">
            <h2><strong>承重力和容量</strong><br><span class="color">為你的事業</span>創造廣闊空間</h2>
          </div>
          <div class="con">
            <p><img src="../../images/videodaily/Overview_dailycab_2.jpg" /></p>
            <h2>為你的事業打造的<strong class="color">車陣王</strong></h2>
            <p>全新DAILY CAB車陣王是<strong>同類車型中用途最廣泛的商用車。</strong>無論是<strong>多站點的派送如郵包送遞或速遞服務，</strong>還是重型運輸工作如<strong>傢俬搬運</strong>-你都可以透過個人化定制從而完美地配合你的經營與業務需求。</p>
            <p style="margin:0;"><strong>超耐用設計</strong></p>
            <p>
              <ol>
                <li class="lstyle">每日以最大限度裝滿全新DAILY，年復一年，印證它是值得信賴，並可有效完成任何任務。</li>
                <li class="lstyle">這是唯一一款採用貨車車般堅固鋼底盤的輕型尾架車，側梁厚達5 mm，可充分享用其力量帶來的好處。</li>
                <li class="lstyle">更大的負載能力，高達4900 kg，讓您可更快完成工作，減少車程。</li>
              </ol>
            </p>
            <el-button class="button-more"
                       @click="dialogVisibleData = true">詳情<i class="el-icon-arrow-right"></i></el-button>

            <el-dialog class="vdialog"
                       title=""
                       :visible.sync="dialogVisibleData"
                       :before-close="handleClose"
                       :lockScroll="true"
                       size="tiny">
              <div class="tableScroll">
                <table class="tableData"
                       border="0"
                       cellpadding="2"
                       cellspacing="2">
                  <tbody>
                    <tr>
                      <td colspan="1"
                          rowspan="3"
                          style="background-color:white;"> <strong>軸距(mm)<br /></strong> </td>
                      <td colspan="4"
                          rowspan="1"
                          style="vertical-align:top;text-align:center;background-color:#3466cd;color:white;"> <strong>尾架長度(mm)</strong></td>
                      <td colspan="4"
                          rowspan="1"
                          style="vertical-align:top;text-align:center;background-color:#3466cd;color:white;"> <strong>車輛總重(t)</strong></td>
                    </tr>
                    <tr>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;"> <strong>單後輪</strong></td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;"> <strong>雙後輪</strong></td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;"> <strong>單排座駕駛室底盤</strong></td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;"> <strong>雙排座駕駛室底盤</strong></td>
                    </tr>
                    <tr>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;text-align:center;"> <img src="../../images/videodaily/single-wheel.png"
                             alt="single-wheel" /> <br /> </td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;text-align:center;"> <img src="../../images/videodaily/twin-wheel.png"
                             alt="twin-wheel" /> <br /> </td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;text-align:center;"> <img src="../../images/videodaily/chassis-cab.png"
                             alt="chassis-cab" /> <br /> </td>
                      <td colspan="2"
                          rowspan="1"
                          style="vertical-align:top;background-color:white;text-align:center;"> <img src="../../images/videodaily/crew-cab.png"
                             alt="crew-cab" /> <br /> </td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;"> <strong>MIN.</strong></td>
                      <td style="vertical-align:top;"> <strong>MAX.</strong></td>
                      <td style="vertical-align:top;"> <strong>MIN.</strong></td>
                      <td style="vertical-align:top;"> <strong>MAX.</strong></td>
                      <td style="vertical-align:top;"> <strong>MIN.</strong></td>
                      <td style="vertical-align:top;"> <strong>MAX.</strong></td>
                      <td style="vertical-align:top;"> <strong>MIN.</strong></td>
                      <td style="vertical-align:top;"> <strong>MAX.</strong></td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">3000</td>
                      <td style="vertical-align:top;">2510</td>
                      <td style="vertical-align:top;">3000</td>
                      <td style="vertical-align:top;">2830</td>
                      <td style="vertical-align:top;">3316</td>
                      <td style="vertical-align:top;">3.3</td>
                      <td style="vertical-align:top;">5.2</td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">3450</td>
                      <td style="vertical-align:top;">3395</td>
                      <td style="vertical-align:top;">3886</td>
                      <td style="vertical-align:top;">3395</td>
                      <td style="vertical-align:top;">3886</td>
                      <td style="vertical-align:top;">3.3</td>
                      <td style="vertical-align:top;">7<br /> </td>
                      <td style="vertical-align:top;">3.3</td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">3750</td>
                      <td style="vertical-align:top;">4005</td>
                      <td style="vertical-align:top;">4495</td>
                      <td style="vertical-align:top;">4005</td>
                      <td style="vertical-align:top;">4495</td>
                      <td style="vertical-align:top;">3.5</td>
                      <td style="vertical-align:top;">7.2</td>
                      <td style="vertical-align:top;">3.5</td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">4100</td>
                      <td style="vertical-align:top;">4005</td>
                      <td style="vertical-align:top;">4495</td>
                      <td style="vertical-align:top;">4005</td>
                      <td style="vertical-align:top;">4895</td>
                      <td style="vertical-align:top;">3.5</td>
                      <td style="vertical-align:top;">7.2</td>
                      <td style="vertical-align:top;">3.5</td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">4350</td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;">4830</td>
                      <td style="vertical-align:top;">5340</td>
                      <td style="vertical-align:top;">5.2</td>
                      <td style="vertical-align:top;">7.2</td>
                      <td style="vertical-align:top;">5.2<br /> </td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">4750</td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;">5690</td>
                      <td style="vertical-align:top;">6190</td>
                      <td style="vertical-align:top;">5.2</td>
                      <td style="vertical-align:top;">7.2</td>
                      <td style="vertical-align:top;">6</td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                    <tr>
                      <td style="vertical-align:top;">5100</td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;"> <br /> </td>
                      <td style="vertical-align:top;">5690</td>
                      <td style="vertical-align:top;">6190</td>
                      <td style="vertical-align:top;">6<br /> </td>
                      <td style="vertical-align:top;">7.2</td>
                      <td style="vertical-align:top;">6</td>
                      <td style="vertical-align:top;">7</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                       target="_blank"
                       class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
            </el-dialog>
          </div>

          <div ref="videoDaily2_con"
               class="con">
            <h2>全新DAILY CAB車陣王</h2>
            <div class="video360">
              <!-- <span>全新DAILY 360˚</span> -->
              <el-tabs v-model="active360">
                <el-tab-pane label="　　全新DAILY 360˚　　"
                             name="v1">
                  <video ref="videoDaily2"
                         muted
                         webkit-playsinline="true"
                         playsinline="true"
                         x5-playsinline="true"
                         class="video-product"
                         style="width: 100%; margin-top:0;"
                         poster="../../images/videodaily/Daily Chassis Cab 360.jpg"
                         controls="controls"
                         width="100%"
                         height="auto">
                    <source :src="`${url}/iveco/iveco-images/videodaily/video/Daily Chassis Cab 360.mp4`"
                            type="video/mp4">
                  </video>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </PTabPane>
        <PTabPane label="頂級發動機性能"
                  name="3">
          <div class="load-title">
            <h2><strong>頂級發動機性能</strong><br>為你的事業帶來可<span class="color">持續發展及符合經濟效益</span></h2>
          </div>
          <div class="con">
            <p><img src="../../images/videodaily/Overview_dailycab_3.jpg" /></p>
            <h4><strong class="color">DAILY的高效性能為你實現更顯著的慳油效果</strong></h4>
            <p>全新DAILY引擎的<strong>燃油效能脫穎而出，</strong>這得益於其補充特性，例如<strong>新的電控可變截面渦輪增壓器，</strong>專為DAILY獨家打造的<strong>Super Eco節能輪胎</strong>和<strong>全新Auto Start/Stop自動停車熄匙系統。</strong></p>
            <h4><strong class="color">大大節省的維修費用</strong></h4>
            <p>不斷的創新和更長的換油週期，在城市環境中工作時可<strong>節省更多的的維護成本。</strong></p>
            <h4><strong class="color">時刻發揮頂尖性能</strong></h4>
            <p>全新DAILY以其廣泛的引擎陣容而聞名，<strong>配備兩種為最優化的引擎，無論任何任務都可發揮頂尖性能。</strong></p>
          </div>

          <div class="con">
            <h2>全新DAILY CAB車陣王</h2>
            <div class="videoF1A">
              <el-tabs v-model="activeF1A">
                <el-tab-pane label="　　2.3升F1A引擎　　"
                             name="F1">
                  <h4>2.3升F1A引擎</h4>
                  <table class="tableF1A"
                         cellspacing="2"
                         cellpadding="2"
                         border="0">
                    <tbody>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">車型</td>
                        <td>160</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">功率 (hp)</td>
                        <td>156 (116 kW)</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">扭矩(Nm)</td>
                        <td>380</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">渦輪增壓</td>
                        <td>電控可變截面渦輪增壓器</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">波箱</td>
                        <td>HI-MATIC / 手動</td>
                      </tr>
                    </tbody>
                  </table>
                  <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                           target="_blank"
                           class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
                </el-tab-pane>
                <el-tab-pane label="　　3.0升F1A引擎　　"
                             name="F2">
                  <h4>3.0升F1A引擎</h4>
                  <table class="tableF1A"
                         cellspacing="2"
                         cellpadding="2"
                         border="0">
                    <tbody>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">車型</td>
                        <td>180</td>
                        <td>210</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">功率 (hp)</td>
                        <td>180 (134 kW)</td>
                        <td>210 (156 kW)</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">扭矩(Nm)</td>
                        <td>430</td>
                        <td>470</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">渦輪增壓</td>
                        <td>可變截面渦輪增壓器</td>
                        <td>電控可變截面渦輪增壓器</td>
                      </tr>
                      <tr>
                        <td style="text-align:left;font-weight:bold;">波箱</td>
                        <td>HI-MATIC / 手動</td>
                        <td>HI-MATIC</td>
                      </tr>
                    </tbody>
                  </table>
                  <el-link href="https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/"
                           target="_blank"
                           class="button-products">產品介紹書<i class="el-icon-arrow-right"></i></el-link>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>

          <div class="con ovfl">
            <div class="con-c-left">
              <h2 class="no-bold"><span class="color">有HI-MATIC</span>，更舒適，更安全 </h2>
              <p>專注於交通狀況和駕駛條件，餘下一切交給首款八速全自動波箱HI-MATIC打理。 </p>
            </div>
            <div class="con-c-right">
              <img src="../../images/videodaily/Overview_3_1.jpg" />
            </div>
          </div>

        </PTabPane>
        <PTabPane label="內飾和駕駛體驗"
                  name="4">
          <div class="load-title">
            <h2><strong>內部<span style="font-weight: 600;"
                      class="color">更舒適</span></strong><br>你值得擁有的駕駛體驗！</h2>
          </div>
          <div ref="videoDaily4_con_top"
               class="con">
            <h3>科技服務你左右</h3>
            <div ref="videoDaily4_con"
                 class="tabsInteriors">
              <swiperx ref="mySwiper"
                       :options="swiperOption"
                       class="swiper-container swiper-tabs">
                <swiper-slide :class="[{current: swiperOption.currentIndex == index}, 'wiper-slide tabs-slide']"
                              v-for="(tabs, index) in swiperTabs1"
                              :key="index">
                  <span style="white-space: pre-wrap;">{{tabs.title}}</span>
                </swiper-slide>
                <div class="swiper-button-prev tabs-prev"
                     slot="button-prev"></div>
                <div class="swiper-button-next tabs-next"
                     slot="button-next"></div>
                <div class="swiper-scrollbar tabs-scrollbar"
                     slot="scrollbar"></div>
              </swiperx>

              <swiperx ref="mySwiperBox"
                       :options="swiperOptionBox"
                       class="swiper-container tabs-box">
                <swiper-slide class="swiper-slide box-slide swiper-no-swiping"
                              v-for="(box, index) in swiperTabsBox1"
                              :key="index">
                  <img v-if="box.img=='' ? false : true"
                       :src="box.img"
                       :alt="box.title" />
                  <video ref="videoDaily4"
                         webkit-playsinline="true"
                         playsinline="true"
                         x5-playsinline="true"
                         v-if="box.img=='' ? true : false"
                         class="video-product"
                         poster="../../images/videodaily/videoElectric-ok2.jpg"
                         controls="controls"
                         width="70%"
                         height="auto">
                    <source :src="`${url}/iveco/iveco-images/videodaily/video/Electricparkingbrake.mp4`"
                            type="video/mp4">
                  </video>
                  <h5>{{box.title}}</h5>
                  <p>{{box.txt}}</p>
                </swiper-slide>
              </swiperx>
            </div>
          </div>

          <div ref="rtestateField"
               class="rtestate-field">
            <iframe style="width: 100%; height: 100%;"
                    src="https://www.ivecohk.com/vr360/tour.html"
                    frameborder="0"></iframe>
            <!-- <div id="pano" style="width: 100%; height: 100%;"></div> -->
          </div>

        </PTabPane>
        <PTabPane label="輔助駕駛和安全"
                  name="5">
          <div class="load-title">
            <h2><strong>輔助駕駛和安全</strong><br>享受安全，<span class="color">輕鬆的駕駛</span></h2>
          </div>
          <div ref="videoDaily5_con_h"
               class="con">
            <h2>輔助駕駛和安全</h2>
            <p>DAILY配備了整套<strong>最先進的輔助駕駛系統，</strong>減少了在高速公路和繁忙的城市街道上發生事故的風險，在棘手的情況下為你提供幫助，並減輕了交通擠塞的壓力，從而進一步<strong>提高工作及生活品質。</strong></p>
          </div>
          <div ref="videoDaily5_con"
               class="con">
            <h3>DAILY配備輔助駕駛系統</h3>
            <div class="tabsInteriors">
              <swiperx ref="mySwiperx"
                       :options="swiperOptionx"
                       class="swiper-container swiper-tabs">
                <swiper-slide :class="[{current: swiperOptionx.currentIndex == index}, 'wiper-slide tabs-slide']"
                              v-for="(tabs, index) in swiperTabs2"
                              :key="index">
                  <span style="white-space: pre-wrap;">{{tabs.title}}</span>
                </swiper-slide>
                <div class="swiper-button-prev tabs-prev"
                     slot="button-prev"></div>
                <div class="swiper-button-next tabs-next"
                     slot="button-next"></div>
                <div class="swiper-scrollbar tabs-scrollbar"
                     slot="scrollbar"></div>
              </swiperx>

              <swiperx ref="mySwiperxBox"
                       :options="swiperOptionxBox"
                       class="swiper-container tabs-box">
                <swiper-slide class="swiper-slide box-slide swiper-no-swiping"
                              v-for="(box, index) in swiperTabsBox2"
                              :key="index">
                  <video ref="videoDaily5"
                         webkit-playsinline="true"
                         playsinline="true"
                         x5-playsinline="true"
                         class="video-product"
                         controls="controls"
                         width="70%"
                         height="auto"
                         poster="../../images/videodaily/video_daily_ADV_ok3.jpg">
                    <source :src="box.video"
                            type="video/mp4">
                  </video>
                  <h5>{{box.title}}</h5>
                  <p>{{box.txt}}</p>
                </swiper-slide>
              </swiperx>

            </div>
          </div>
        </PTabPane>
        <PTabPane label="圖片庫"
                  name="6">
          <div class="load-title">
            <h2><strong>圖片庫</strong><br><span class="color">全新DAILY</span>彰顯個性</h2>
          </div>
          <div class="con ovfl">
            <div class="img-box"
                 v-for="(url, index) in tableImage"
                 :style="{'background-image': 'url(' + url + ')'}"
                 :key="index">
              <img preview="repairDetail"
                   preview-text=""
                   :src="url"
                   alt="">
            </div>
          </div>
        </PTabPane>
        <PTabPane label="產品介紹書"
                  name="7"></PTabPane>
      </PTabs>
    </div>
    <Footer />
  </div>
</template>

<script>

import Swiper from 'swiper'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import PubSub from 'pubsub-js'
// import 'swiper/dist/css/swiper.css'
import Header from '../../components/Header.vue'      //公共头部
import Footer from '../../components/Footer.vue'      //底部

export default {
  name: 'ProductsDetail2',
  data () {
    return {
      url: this.$store.state.baseURL,
      videoDaily1T: '',
      videoDaily2T: '',
      videoDaily4T: '',
      videoDaily5T: '',
      videoIndex: '',
      videoListIndex: '0',
      screenWidth: document.body.clientWidth,
      screenScroll: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
      activeName: '1',
      qtab: 7,
      active360: 'v1',
      activeF1A: 'F1',
      activeInteriors: '1',
      dialogVisibleConsuption: false,
      dialogVisibleWeight: false,
      dialogVisibleOutline: false,
      dialogVisibleData: false,
      slides: 4,
      swiperOptionx: {
        currentIndex: 0,
        slidesPerView: 3,
        // spaceBetween: 30,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        notNextTick: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, //滚动条是否自动隐藏。默认：false，不会自动隐藏。
          draggable: true,
          snapOnRelease: true,
        },
        on: {
          resize () {
            let that = this
            if (screenWidth >= 992) {
              that.params.slidesPerView = 4.5
            } else if (screenWidth >= 600) {
              that.params.slidesPerView = 3
            } else {
              that.params.slidesPerView = 2
            }
          },
          init () {
            //Swiper初始化了
            let that = this
            let w = document.body.clientWidth
            if (w >= 992) {
              that.params.slidesPerView = 4.5
            } else if (w >= 600) {
              that.params.slidesPerView = 3
            } else {
              that.params.slidesPerView = 2
            }
          },
          slideChangeTransitionEnd () {
            if (this.isEnd) {
              this.navigation.$nextEl.css('display', 'none')
            } else {
              this.navigation.$nextEl.css('display', 'block')
            }
          },
          tap: () => {
            let that = this
            let videoDaily5 = this.$refs.videoDaily5
            let swiper1 = this.$refs.mySwiperx.swiper
            let swiper2 = this.$refs.mySwiperxBox.swiper
            swiper2.slideTo(swiper1.clickedIndex)
            // console.log('video1', video1)
            // console.log('swiper1',swiper1.slides[0])
            if (swiper1.clickedIndex == swiper2.activeIndex) {
              this.swiperOptionx.currentIndex = swiper1.clickedIndex
              videoDaily5.forEach((val, i) => {
                if (swiper2.activeIndex == i) {
                  that.videoListIndex = i
                  // console.log('that.videoListIndex', that.videoListIndex)
                  setTimeout(function () {
                    that.getscreenWidth()
                    that.windowDetailScroll()
                  }, 300)
                } else {
                  val.pause()
                }
              })
            }
          }
        }
      },
      swiperOptionxBox: {
        effect: 'fade',
        // spaceBetween: 30,
        autoHeight: true
      },

      //科技服務你左右
      swiperOption: {
        currentIndex: 0,
        slidesPerView: 3,
        // spaceBetween: 30,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, //滚动条是否自动隐藏。默认：false，不会自动隐藏。
          draggable: true,
          snapOnRelease: true,
        },
        on: {
          resize () {
            let that = this
            if (screenWidth >= 992) {
              that.params.slidesPerView = 4.5
            } else if (screenWidth >= 600) {
              that.params.slidesPerView = 3
            } else {
              that.params.slidesPerView = 2
            }
          },
          init () {
            //Swiper初始化了
            let that = this
            let w = document.body.clientWidth
            if (w >= 992) {
              that.params.slidesPerView = 4.5
            } else if (w >= 600) {
              that.params.slidesPerView = 3
            } else {
              that.params.slidesPerView = 2
            }
          },
          slideChangeTransitionEnd () {
            if (this.isEnd) {
              this.navigation.$nextEl.css('display', 'none')
            } else {
              this.navigation.$nextEl.css('display', 'block')
            }
          },
          tap: () => {
            let that = this
            let videoDaily4 = that.$refs.videoDaily4[0]
            let swiper1 = this.$refs.mySwiper.swiper
            let swiper2 = this.$refs.mySwiperBox.swiper
            swiper2.slideTo(swiper1.clickedIndex)
            // console.log('swiper1',swiper1)
            // console.log('video0',video0)
            if (swiper1.clickedIndex == swiper2.activeIndex) {
              this.swiperOption.currentIndex = swiper1.clickedIndex
            }
            if (this.activeName == 4 && swiper1.clickedIndex == 6) {
              that.videoIndex = swiper1.clickedIndex
              setTimeout(function () {
                that.getscreenWidth()
                that.windowDetailScroll()
              }, 300)
            } else {
              videoDaily4.pause()
            }
          }
        }
      },
      //科技服務你左右
      swiperOptionBox: {
        effect: 'fade',
        // spaceBetween: 30,
        autoHeight: true
      },
      swiperTabs1: [
        { id: 1, title: '順暢自如地操控' },
        { id: 2, title: '出色的駕駛舒適度和\n人體工學設計' },
        { id: 3, title: '簡單清晰\n的互動體驗' },
        { id: 4, title: '實時胎壓監測系統\n確保安全和效率' },
        { id: 5, title: 'HI-CONNECT\n全新的信息控制系統' },
        { id: 6, title: '全新LED\n大燈' },
        { id: 7, title: '電子手制' },
      ],
      swiperTabsBox1: [
        { id: 1, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_1.jpg', title: '順暢、自如地操控', txt: '新的電子助力轉向系統能非常精確及靈敏地回應駕駛者的指令，減少轉向用力，使駕駛過程順暢自如。它還可以減少振動，在車輛轉彎和發生打滑時保持車身穩定。只需按下按鈕，就可以啟動城市模式，可減少高達70%的方向盤阻力。即便是在繁忙的市中心街道，也能享受駕駛的愉悅感。' },
        { id: 2, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_2.jpg', title: '出色的駕駛舒適度和人體工學設計', txt: 'DAILY的整個轉向系統經過重新設計，帶來轎車般的行車體驗。方向盤可以雙向調節，設定最佳駕駛位置，確保舒適度並符合人體工學。更小巧的皮革多功能方向盤將大量控制按鈕佈置在觸手可及之處，留出更多腿部空間，提升整體舒適度。' },
        { id: 3, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_3.jpg', title: '簡單清晰的互動體驗', txt: 'DAILY的全新高解析度彩色顯示屏提供方便使用的直觀介面，與車輛之間的互動變得十分簡便，一切資訊及控制皆能輕鬆地掌控。' },
        { id: 4, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_4.jpg', title: '實時胎壓監測系統確保安全和效率', txt: '胎壓監測系統在顯示屏上即時顯示每個輪胎的氣壓，確保DAILY能在最佳胎壓下行駛。這不僅使駕駛更安全，還有助於減少耗油量。DAILY是同級車型中首款為單輪和雙輪產品都配備該功能的車型。' },
        { id: 5, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_5.jpg', title: 'HI-CONNECT：全新的信息控制系統', txt: 'DAILY設有一個方便使用的信息控制系統，帶有7英寸屏幕，駕駛風格評估，語音識別及後置倒車鏡頭顯示。你亦可以透過Apple CarPlay和AndroidAuto™輕鬆地接駁到手機的應用程式，在車箱內可安全地享受應用程式所帶來的便利享受。' },
        { id: 6, img: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/Overview_4_6.jpg', title: '全新LED大燈', txt: '大幅改善了駕駛視野及障礙感知，提升幅度達到15%，光線更遠更清晰。設計風格鮮明，同時超長使用壽命還能有效降低駕車成本。輕鬆愜意，毫不費力。' },
        { id: 7, img: '', title: '電子手制', txt: '新的電子手制在停車時自動接合，預備行駛時自動斷開。特別在城市中需要頻繁泊車時(例如速遞送貨)，駕駛者不必浪費時間反復拉動手制。這不僅能緩解重複操作引起的手臂疲勞和不適，還可提升工作效率，每月最多可節省5小時，提高生產力。取替手制杆的設計，也讓駕駛空間更自由，行動更方便。' },
      ],
      swiperTabs2: [
        { id: 1, title: '先進的輔助駕駛系統' },
        { id: 2, title: '自動緊急煞車系統' },
        { id: 3, title: '排隊輔助系統' },
        { id: 4, title: '自調巡航控制系統' },
        { id: 5, title: '防偏離線道輔助系統' },
        { id: 6, title: '側風車身穩定系統' },
        { id: 7, title: '陡坡緩速控制系統及\n牽引力控制系統' },
      ],
      swiperTabsBox2: [
        { id: 1, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Assisted driving & safety.mp4', title: '先進的輔助駕駛系統', txt: '讓你在完全的狀態下專注於你日益繁雜的工作。與此同時，這些技術還能降低車輛在高速公路和城市繁忙街道上的事故風險，讓你從容應對複雜的交通狀況，從而進一步提高工作及生活品質。' },
        { id: 2, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Advanced Emergency braking system.mp4', title: '城市煞車輔助系統', txt: '先進的自動緊急煞車系統和城市煞車輔助系統通過檢測潛在的碰撞風險並自動急煞確保駕駛者的安全。城市煞車輔助系統在繁忙的車流中，低於5km/h車速時，系統會自動啟動並有效防止碰撞事故的發生。' },
        { id: 3, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Queue Assist.mp4', title: '排隊輔助系統', txt: '在交通繁忙的路段，你可以按動排隊輔助系統的按鈕來設置和前車需要保持的安全距離，DAILY就會在前車煞車時自動停車。當前車重新開動後，只需輕踩一下油門便可再次啟DAILY。高峰時間的緊張感隨即一掃而空!' },
        { id: 4, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Adaptive cruise control.mp4', title: '自調巡航控制系統', txt: '自調巡航控制系統能夠設置行駛速度以及與前方車輛之間的最短距離，以確保駕駛者的安全。' },
        { id: 5, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Proactive lane keeping assist.mp4', title: '防偏離線道輔助系統', txt: 'DAILY配備的防偏離線道輔助系統可以確保在車輛逐漸偏離行車線後自動調整返回當前的行車線。' },
        { id: 6, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Crosswind Assist.mp4', title: '側風車身穩定系統', txt: '借助DAILY的側風車身穩定系統，強風觸動感應器從而啟動系統，確保車輛穩定而安全地行駛。' },
        { id: 7, video: this.$store.state.baseURL + '/iveco/iveco-images/videodaily/video/Hill Descent Control & traction plus.mp4', title: '陡坡緩速控制系統及牽引力控制系統', txt: '陡坡緩速控制系統讓駕駛者在長而陡峭的斜坡上緩慢安全地駕駛車輛下坡。 當面對泥濘、沙土或雪地等濕滑表面時，牽引力控制系統可以使車輛保持牢固的抓地力，使駕駛者擺脫困境。' },
      ],
      tableImage: [
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/01.jpg',
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/02.jpg',
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/02a.jpg',
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/03.jpg',
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/04.jpg',
        this.$store.state.baseURL + '/iveco/iveco-images/videodaily/dailycabimages/05.jpg'
      ]
    }
  },
  mounted () {
    // embedpano({
    //   swf:"/static/vtour/tour.swf", 
    //   xml:"/static/vtour/tour.xml", 
    //   target:"pano", 
    //   html5:"auto", 
    //   mobilescale:1.0, 
    //   passQueryParameters:true
    // })

    let that = this

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    setTimeout(function () {
      that.getscreenWidth()
      window.addEventListener('scroll', that.windowDetailScroll)
    }, 500)
  },
  methods: {
    // 浏览器窗口大小
    getscreenWidth () {
      let that = this
      // let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight //浏览器高度

      if (that.activeName == 1) {
        let videoDaily1_con = that.$refs.videoDaily1_con
        that.videoDaily1T = that.$refs.detail.offsetTop + videoDaily1_con.offsetTop + 52 - videoDaily1_con.offsetHeight / 2
      }
      if (that.activeName == 2) {
        let videoDaily2 = that.$refs.videoDaily2
        let videoDaily2_con = that.$refs.videoDaily2_con
        that.videoDaily2T = that.$refs.detail.offsetTop + videoDaily2_con.offsetTop + 52 - videoDaily2.offsetHeight / 2
      }
      if (that.activeName == 4) {
        let videoDaily4_con = that.$refs.videoDaily4_con
        let videoDaily4_con_top = that.$refs.videoDaily4_con_top
        // that.videoDaily4T = that.$refs.detail.offsetTop + videoDaily4_con.offsetTop + videoDaily4_con_top.offsetTop + 52 - videoDaily4_con.offsetHeight/2
        that.videoDaily4T = that.$refs.detail.offsetTop - 52
      }
      if (that.activeName == 5) {
        let videoDaily5_con = that.$refs.videoDaily5_con
        let videoDaily5_con_h = that.$refs.videoDaily5_con_h
        that.videoDaily5T = that.$refs.detail.offsetTop + videoDaily5_con.offsetTop - videoDaily5_con_h.offsetHeight
      }
    },
    // 滚动条距离页面顶部的距离
    windowDetailScroll () {
      let that = this
      // 获取窗口滚动条高度
      that.screenScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 获取窗口可视范围的高度
      let thisHeight = document.documentElement.clientHeight
      // 窗口可视范围的高度
      let scrollHeight = document.documentElement.scrollHeight
      // 滚动条到底部的距离
      let bheight = scrollHeight - that.screenScroll - thisHeight

      let videoDaily1 = that.$refs.videoDaily1
      let videoDaily2 = that.$refs.videoDaily2
      let videoDaily4 = that.$refs.videoDaily4[0]
      let videoDaily4_bottom = that.$refs.rtestateField
      let videoDaily5 = that.$refs.videoDaily5

      if (that.activeName == 1 && (that.videoDaily1T - that.screenScroll <= 0 || bheight <= 88)) {
        videoDaily1.play()
        videoDaily2.pause()
        videoDaily4.pause()
        videoDaily5[that.videoListIndex].pause()
        console.log('videoDaily1开始')
      } else if (that.activeName == 2 && (that.videoDaily2T - that.screenScroll <= 0 || bheight <= 88)) {
        videoDaily2.play()
        videoDaily1.pause()
        videoDaily4.pause()
        videoDaily5[that.videoListIndex].pause()
        console.log('videoDaily2开始')
      } else if (that.activeName == 4 && that.videoIndex == 6 && that.screenScroll >= that.videoDaily4T && bheight >= videoDaily4_bottom.offsetHeight / 2) {
        videoDaily4.play()
        videoDaily1.pause()
        videoDaily2.pause()
        videoDaily5[that.videoListIndex].pause()
        console.log('videoDaily4开始')
      } else if (that.activeName == 5 && (that.screenScroll >= that.videoDaily5T || bheight <= 88)) {
        videoDaily5[that.videoListIndex].play()
        // console.log('videoDaily5开始::', that.videoListIndex-1)
      } else {
        videoDaily1.pause()
        videoDaily2.pause()
        videoDaily4.pause()
        videoDaily5[that.videoListIndex].pause()
        // console.log('全部暂停')
      }

    },
    handleClick (tab, event) {
      let that = this
      // document.documentElement.scrollTop = 0
      // document.body.scrollTop = 0
      if (tab.name == 7) {
        if (this.screenWidth > 465) {
          window.open('https://viewer.ipaper.io/iveco-hq/uk/Daily-Cab/')
          this.$router.go(0)
        } else {
          this.$router.push({ path: "/loading", query: { key: 'NewDailyCab' } })
        }
      }

      that.activeName = tab.name
      setTimeout(function () {
        that.getscreenWidth()
        that.windowDetailScroll()
      }, 300)
    },
    handleClose () {
      this.dialogVisibleConsuption = false
      this.dialogVisibleWeight = false
      this.dialogVisibleOutline = false
      this.dialogVisibleData = false
    }
  },
  components: {
    Header,
    Footer,
    swiperx: swiper,
    swiperSlide
  },
  destroyed () {
    let that = this
    window.removeEventListener("scroll", that.windowDetailScroll)
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        let that = this
        that.screenWidth = val
        // console.log('screenWidthscreenWidthscreenWidth', that.screenWidth)
        // setTimeout(function () {
        //     that.getscreenWidth()
        // }, 400)
      }
    }
  }
}
</script>

<style>
/* 横向滚动条颜色 */
.swiper-scrollbar {
  background: rgba(0, 0, 0, 0);
}
.swiper-scrollbar-drag {
  background: #bfbfbf;
}

/* 顺直居中 */
.my-bullet {
  background: #000;
}
.swiper-button-disabled {
  display: none;
}
.p-tabs__item {
  font-size: 16px;
  height: 58px;
  line-height: 58px;
}
.p-tabs__header {
  width: 100%;
  /* width: 1440px; */
  margin: 0 auto;
  display: flex;
  justify-content: center;
  background: #f3f3f3;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  z-index: 99;
}

.p-tabs--card > .p-tabs__header {
  border-bottom: none;
}
.p-tabs--card > .p-tabs__header .p-tabs__nav {
  border: 0 solid #e4e7ed !important;
}
.p-tabs--card > .p-tabs__header .p-tabs__item {
  border-bottom: 0;
  background: #f3f3f3;
  border-left: 1px solid #eee;
}
.p-tabs--card > .p-tabs__header .p-tabs__item:first-child {
  border-left: 0;
}
/* .p-tabs--card>.p-tabs__header .p-tabs__item:hover {
    color: #00336f;
  }
  .p-tabs--card>.p-tabs__header .p-tabs__item.is-active {
    background: #00336f;
    color: #fff;
  } */
.p-tabs__nav-wrap.is-scrollable {
  padding: 0 26px;
}
.p-tabs__nav-next,
.p-tabs__nav-prev {
  font-size: 26px;
  line-height: 60px;
}
.p-tabs__content {
  background: #eeeeee;
}

/* 弹窗 */
.el-dialog {
  width: 90% !important;
}
.el-dialog__header .el-dialog__title {
  font-size: 22px;
  font-weight: 600;
  color: #595959;
}
.el-dialog__body {
  text-align: left;
  color: #595959;
}
.el-tabs__nav-scroll {
  overflow-x: scroll;
}
/* 360度视频 与  参数  与 科技*/
.video360 .el-tabs .el-tabs__header,
.videoF1A .el-tabs .el-tabs__header,
.tabsInteriors .el-tabs .el-tabs__header {
  width: 100%;
  text-align: left;
  margin: 0;
  padding: 0;
  display: block;
  justify-content: normal;
}
.video360 .el-tabs__nav-scroll,
.videoF1A .el-tabs__nav-scroll,
.tabsInteriors .el-tabs__nav-scroll {
  border-bottom: 2px solid #ddd;
}
.video360 .el-tabs__item,
.videoF1A .el-tabs__item,
.tabsInteriors .el-tabs__item {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  height: 40px;
  line-height: 40px;
  padding-left: 40px;
}
.video360 .el-tabs__item.is-active,
.videoF1A .el-tabs__item.is-active,
.tabsInteriors .el-tabs__item.is-active {
  color: #3466cd;
}
.video360 .el-tabs__active-bar,
.videoF1A .el-tabs__active-bar,
.tabsInteriors .el-tabs__active-bar {
  height: 4px;
  background-color: #3466cd;
}

.video360 .el-tabs__content,
.videoF1A .el-tabs__content,
.tabsInteriors .el-tabs__content {
  background: #fff;
}
.videoF1A .el-tabs__content {
  padding: 10px;
}
.videoF1A .el-tabs__content h4 {
  font-family: sans-serif;
  font-size: 28px !important;
  font-weight: 300 !important;
  text-align: center;
  padding: 0 0 20px 0;
}
.tabsInteriors .el-tabs .el-tabs__item {
  height: auto;
  line-height: 22px;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 6px;
}
.tabsInteriors .el-tabs__item {
  padding: 0 16px;
}

@media (min-width: 1439px) {
  .p-tabs__header {
    width: 1440px;
  }
}
@media (min-width: 468px) {
  .el-dialog {
    width: 84% !important;
  }
  /* .p-tabs__header_fixed .p-tabs__header {
      width: 100%;
    } */
  .videoF1A .el-tabs__content {
    padding: 22px;
  }
}

@media (min-width: 568px) {
  .el-dialog {
    width: 74% !important;
    max-width: 1000px;
  }
}
</style>


<style lang="stylus" ref="stylesheet/stylus" scoped>
.lstyle {
  list-style: inside;
}

.c-on1 {
  display: none;
}

.c-on2 {
  display: block;

  span {
    font-size: 19px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px 10px;
    width: 100%;
    display: inline-block;
  }
}

.color {
  color: #3466cd;
}

.no-bold {
  font-weight: 300 !important;
}

.ovfl {
  overflow: hidden;
}

.el-breadcrumb__inner a {
  font-weight: normal;

  &:hover {
    color: #606266;
  }
}

#ProductsDetail {
  background: #f4f4f4;
  position: relative;
  max-width: 1440px;
  margin: 0 auto;
  box-shadow: 0 0 16px #a6a6a6;

  .bg-img {
    img {
      margin: 0 auto;
    }
  }

  .breadcrumb-bg {
    margin-top: 50px;
    text-transform: uppercase;
    // margin-top: 50px;
    box-shadow: 0 3px 2px rgba(0, 0, 0, 0.1);
    background: #f3f3f3;

    .breadcrumb {
      padding: 10px 10px 6px !important;
    }

    .el-breadcrumb {
      font-size: 13px;
      line-height: 16px;
      padding: 10px 0;
      background: #f3f3f3;

      span {
        padding-bottom: 3px;

        &:last-of-type {
          width: 170px;
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .detail {
    width: 100%;
    margin: 0 auto;

    // max-width: 1300px;
    .load-title {
      margin: 40px 0 20px;
      text-align: center;

      h2 {
        font-size: 28px;
        line-height: 44px;

        strong {
          font-size: 16px;
        }
      }
    }

    .con {
      width: 100%;
      margin: 14px auto 8px;
      background: #fff;
      padding: 16px 16px;

      h2 {
        font-size: 24px;
        font-weight: 600;
        margin-top: 16px;
        margin-bottom: 13px;
      }

      p {
        font-size: 15px;
        line-height: 30px;
        // margin-bottom: 18px;
        margin-bottom: 10px;
      }

      p.margin18 {
        margin-bottom: 18px;
      }

      p.no-margin {
        margin: 0;
      }

      h3 {
        font-size: 22px;
        font-weight: 600;
        margin: 20px 0 14px;
      }

      h5 {
        font-size: 18px;
        font-weight: 600;
        padding: 0px 0 20px;
        margin: 0px 0 10px;
      }

      .three-list {
        display: flex;
        flex-direction: column;

        // flex-direction: row;
        li {
          text-align: center;
          line-height: 23px;
          flex-grow: 1;
          border-bottom: solid 1px rgba(0, 0, 0, 0.2);
          margin-bottom: 10px;
          padding-bottom: 22px;

          img {
            margin: 0 auto;
          }

          i {
            font-size: 32px;
            color: #3466cd;
            cursor: pointer;
          }
        }
      }

      .button-more {
        width: 128px;
        height: 36px;
        line-height: 36px;
        color: #fff;
        background: #000;
        padding: 0;
        margin-top: 30px;

        i {
          margin-left: 10px;
        }
      }

      h4 {
        font-size: 18px;
      }

      .con-c-left {
        width: 60%;
        color: #000;
        float: left;
      }

      .con-c-right {
        width: 40%;
        float: right;
      }

      .con-c-left, .con-c-right {
        width: 100%;
      }
    }

    .video-con {
      position: relative;
      padding: 0;

      .video-title {
        width: 87%;
        font-size: 20px;
        line-height: 25px;
        color: white;
        padding-left: 25px;
        padding-top: 19px;
        position: absolute;
        top: 3px;
      }
    }

    .vdialog {
      width: 100%;
    }

    .button-products {
      font-size: 16px;
      width: 90%;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #fff;
      background: #000;
      padding: 0;
      margin: 50px auto 0;
      display: block;

      i {
        font-size: 20px !important;
        color: #fff !important;
        margin-left: 4px !important;
      }
    }

    // 貨車表格
    .carWeight {
      table {
        width: 100%;
        text-align: center;

        th {
          color: #000;
          font-weight: 600;
        }

        th, td {
          padding: 14px;
          border-style: none solid none none;
          border-right-width: 1px;
          border-right-color: #eeeeee;
        }
      }

      .bg {
        td {
          background: #eee;
        }
      }
    }

    // 貨車体积表格
    .tableScroll {
      width: 100%;
      overflow-x: scroll;
      box-sizing: border-box;

      .tableData {
        font-family: 'GillSans', 'Microsoft YaHei', helvetica, sans-serif;
        font-size: 12px;
        color: #444;
        width: 700px;
        text-align: center;
        line-height: 1.2;
        border-spacing: 1px;
        box-sizing: border-box;

        img {
          display: inline-block;
        }

        td {
          border: 1px solid #eee;
          vertical-align: middle;
        }

        th, td {
          padding: 10px;
        }

        tr:nth-child(odd) {
          td {
            background-color: #eee;
          }
        }
      }
    }

    .tableF1A {
      width: 100%;
      text-align: left;

      tr {
        td {
          padding: 15px;
          border: 1px solid #eee;
        }
      }

      tr:nth-child(odd) {
        td {
          background-color: #eee;
        }
      }
    }

    // 科技服务
    .tabsInteriors {
      margin: 30px 0 0 0;

      .tabs-scrollbar {
        left: 0;
        width: 100%;
        height: 4px;
        bottom: 5px;
      }

      .swiper-tabs {
        font-size: 15px;
        // height: 48px;
        // line-height: 48px;
        align-items: center;
        text-align: center;
        cursor: pointer;

        .tabs-prev, .tabs-next {
          width: 20px;
          background-size: 16px 44px;
        }

        .tabs-slide {
          padding: 10px 6px;
        }
      }

      .swiper-slide {
        height: auto;
        padding: 0 6px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        border-bottom: solid 5px #fff;
      }

      .current {
        color: #00336f;
        font-weight: 600;
        border-bottom: solid 5px #3466cd;
      }

      // .swiper-slide-thumb-active {
      // color: #00336f;
      // font-weight: 600;
      // border-bottom: 5px solid #00336f;
      // }
      .box-slide {
        height: auto;
        background: #fff;
        text-align: center;
        margin-top: 0;

        h5 {
          margin: 20px 0 14px 0;
          padding: 0 !important;
        }

        p {
          width: 96%;
          margin: 0 auto;
        }

        img {
          margin: 0 auto;
        }
      }
    }

    // 360度iframe
    .rtestate-field {
      width: 90%;
      height: 200pt;
      margin: 0 auto 30px;
      padding: 0;
    }

    .video-product {
      width: 100%;
      margin: 0 auto;
    }

    // 页面展示多个img标签，且循环渲染出来的
    .img-box {
      float: left;
      width: 30%;
      padding: 15%;
      margin: 1.65%;
      position: relative;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    .img-box img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
}

@media (min-width: 468px) {
  #ProductsDetail {
    .detail {
      .con {
        width: 100%;
        margin: 20px auto 15px;
        background: #fff;
        padding: 20px 30px;

        .three-list {
          flex-direction: column;

          li {
            border-bottom: solid 1px rgba(0, 0, 0, 0.2);
            margin-bottom: 10px;
            padding-bottom: 22px;
          }
        }
      }

      .video-con {
        .video-title {
          font-size: 25px;
          line-height: 30px;
          padding-left: 36px;
          padding-top: 18px;
          top: 29px;
        }
      }

      .button-products {
        font-size: 20px;
        width: 208px;
      }
    }
  }
}

@media (min-width: 768px) {
  #ProductsDetail {
    .breadcrumb-bg {
      margin-top: 50px;
    }

    .detail {
      .load-title {
        margin: 40px 0 20px;
        text-align: center;

        h2 {
          font-size: 30px;

          strong {
            font-size: 16px;
          }
        }
      }

      .con {
        .three-list {
          flex-direction: row;

          li {
            border-bottom: solid 0px rgba(0, 0, 0, 0.2);
            margin-bottom: 0;
            padding-bottom: 0;
          }
        }

        .con-c-left {
          width: 60%;
        }

        .con-c-right {
          width: 40%;
        }

        h2 {
          font-size: 26px;
        }

        p {
          font-size: 16px;
        }
      }

      // 360度iframe
      .rtestate-field {
        width: 80%;
        height: 360pt;
        margin: 0 auto 30px;
        padding: 50px 50px 0;
      }

      .tableScroll {
        .tableData {
          width: 900px;
        }
      }

      .video-product {
        width: 70%;
        margin: 0 auto;
      }

      .tabsInteriors {
        .box-slide {
          p {
            width: 76%;
          }
        }
      }
    }
  }
}

@media (min-width: 899px) {
  #ProductsDetail {
    .detail {
      .con {
        // width: 1100px;
        min-width: 900px;
        max-width: 1300px;
      }
    }
  }
}

@media (min-width: 992px) {
  .c-on1 {
    display: block;
  }

  .c-on2 {
    display: none;
  }

  #ProductsDetail {
    .breadcrumb-bg {
      margin-top: 0;
    }

    .detail {
      .tableScroll {
        .tableData {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/products/new_daily_cab.vue